import { render, staticRenderFns } from "./OnBoardBottomNavbar.vue?vue&type=template&id=36b123f1&scoped=true&"
import script from "./OnBoardBottomNavbar.vue?vue&type=script&lang=js&"
export * from "./OnBoardBottomNavbar.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardBottomNavbar.vue?vue&type=style&index=0&id=36b123f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b123f1",
  null
  
)

export default component.exports